// src/components/SvgSpinner.tsx
import React from 'react';

const SvgSpinner: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Loading…"
  >
    <g transform="translate(1 1)" strokeWidth="2" fill="none" fillRule="evenodd">
      <circle stroke="#e0e0e0" cx="18" cy="18" r="18"/>
      <path stroke="#3498db" d="M36 18c0-9.94-8.06-18-18-18">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 18 18"
          to="360 18 18"
          dur="1s"
          repeatCount="indefinite"/>
      </path>
    </g>
  </svg>
);

export default SvgSpinner;

